import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TrendsetterIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M8.88845 10.1668C8.88845 12.0076 7.95142 12.9446 6.11068 12.9446C5.22662 12.9446 4.37878 12.5934 3.75365 11.9683C3.12853 11.3432 2.77734 10.4953 2.77734 9.61127C2.77734 7.77053 4.26994 6.8335 6.11068 6.8335H8.3329C8.48024 6.8335 8.62155 6.89203 8.72574 6.99621C8.82992 7.1004 8.88845 7.24171 8.88845 7.38905V10.1668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1113 10.1668C11.1113 12.0076 12.0491 12.9446 13.8898 12.9446C14.7739 12.9446 15.6217 12.5934 16.2469 11.9683C16.872 11.3432 17.2232 10.4953 17.2232 9.61127C17.2232 7.77053 15.7306 6.8335 13.8898 6.8335H11.6676C11.5203 6.8335 11.379 6.89203 11.2748 6.99621C11.1706 7.1004 11.1121 7.24171 11.1121 7.38905L11.1113 10.1668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33398 6.8335H11.6673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77713 9.61133H1.66602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3338 9.61133H17.2227"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.88867 10.1665H11.1109"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77734 14.0553L4.3766 12.4561"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2223 14.0553L15.623 12.4561"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
